/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserPublicDto
 */
export interface GetUserPublicDto {
    /**
     * 
     * @type {string}
     * @memberof GetUserPublicDto
     */
    id: string;
}

/**
 * Check if a given object implements the GetUserPublicDto interface.
 */
export function instanceOfGetUserPublicDto(value: object): value is GetUserPublicDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetUserPublicDtoFromJSON(json: any): GetUserPublicDto {
    return GetUserPublicDtoFromJSONTyped(json, false);
}

export function GetUserPublicDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserPublicDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function GetUserPublicDtoToJSON(value?: GetUserPublicDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
    };
}

